import { Outlet } from 'react-router-dom'
import FrameDetectorProvider from '../contexts/frame-detector'

export default function FramePage (): JSX.Element {
  return <FrameDetectorProvider force><Outlet /></FrameDetectorProvider>
}
